import angular from 'angular';
import ngStorage from 'ngstorage';
import ConfigsModule from '../../../configs/configs.js';
import ServicesModule from '../../../services/services.js';
import ResourcesModule from '../../../resources/resources.js';
import Rx from 'rx';
import {normalizeTimeframe} from '../../../common/datetime/date-ranges.js';
import template from './gamesRevenue.jade';

export class GamesRevenueController {
  /* @ngInject */
  constructor($q, GamesLimitedResource,GameDevelopersResource,CampaignAnalyticsResource,TargetingResource,Resource,currentGame,currentGameDeveloper,$filter,$localStorage,currentUser,hideThatProduct) {
    this.GamesLimitedResource = GamesLimitedResource;
    this.GameDevelopersResource = GameDevelopersResource;
    this.TargetingResource = TargetingResource;
    this.MetricResource = Resource(`executive-admin-analytics/new/metric`);
    this.BreakdownMetricResource = Resource(`executive-admin-analytics/new/breakdown`);
    this.translate = $filter('translate');
    this.format = $filter('format');

    this.currentGame = currentGame;
    this.currentGameDeveloper = currentGameDeveloper;
    this.query = new Rx.Subject();
    this.apiDate = $filter('apiDate');
    this.$localStorage = $localStorage;
    this.gamesOfSelectedGameDeveloper = [];
    this.gameDevelopers = [];
    this.setGamesMode = false;
    this.disposables = [];
    this.promises = [];
    this.$q = $q;
    this.hideThatProduct = hideThatProduct;

    this.chartContextReadySubject = new Rx.Subject();
    this.query.subscribe((query) => {
      this.chartContextReadySubject.onNext(true);
    });

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.currency = 'USD';

    this.disposables.push(currentGame.subscribe((game) => {
      this.game = game;
      this.updateCampaignAnalyticsQuery();
    }));

    this.disposables.push(currentGameDeveloper.subscribe((gameDeveloper) => {
      if(gameDeveloper) {
        this.isAGameDeveloperSelected = true;

        if(this.setGamesMode) {
          this.setGamesOfSelectedDeveloper(gameDeveloper);
        }

        if(this.gamesOfSelectedGameDeveloper[0]) {
          this.currentGame.onNext(this.gamesOfSelectedGameDeveloper[0]);
        }
      }
    }));

    this.disposables.push(currentUser.subscribe((user) => {
      if(user) {
        this.user = user;
        if (user.hasRole(['ADMIN']) || user.hasRole(['GG_ACCOUNT_MANAGER']) || user.hasRole(['AGENCY']) || user.hasRole(['ADMIN_AGENCY'])) {
          this.setGamesMode = true;
          this.getGames(true);
        } else {
          this.getGames(false);
        }
      }
    }));

    this.disposeObservable = (d) => { d.dispose() };
    this.$onDestroy = () => { _.forEach(this.disposables, (d) => this.disposeObservable(d)) };
    this.populateSeriesConfig();
  }

  populateSeriesConfig() {
    this.breakdownSeries = [
      {
        metric: 'cost',
        label: 'Revenue',
        format: (() => this.currency)
      },
    ];

    this.series = {
      main: [
        {
          metric: 'cost',
          label: 'Revenue',
          format: (() => this.currency)
        },
      ],
      topCountries: this.breakdownSeries
        .map((serie) => {
          return _.assign({}, serie, {
            type: 'pie',
            showInLegend: true,
            queryParams: {breakdown_dimension: 'country', top_n: 20},
            transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
          });
        }),
      topPlatforms: this.breakdownSeries
        .map((serie) => {
          return _.assign({}, serie, {
            type: 'pie',
            showInLegend: true,
            queryParams: {breakdown_dimension: 'platform', top_n: 20},
            transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
          });
        }),
      topChannels: this.breakdownSeries
      .map((serie) => {
        return _.assign({}, serie, {
          type: 'pie',
          showInLegend: true,
          queryParams: {breakdown_dimension: 'channel', top_n: 20},
          transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
        });
      }),
      topGames: this.breakdownSeries
      .map((serie) => {
        return _.assign({}, serie, {
          type: 'pie',
          showInLegend: true,
          queryParams: {breakdown_dimension: 'game_id', top_n: 20},
          transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
        });
      }),
      topGameDevelopers: this.breakdownSeries
      .map((serie) => {
        return _.assign({}, serie, {
          type: 'pie',
          showInLegend: true,
          queryParams: {breakdown_dimension: 'game_developer_id', top_n: 20},
          transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
        });
      }),
    };
  }

  getNewSerie(series, metric) {
    let newSerie = _.cloneDeep(series[0] || {data: {}});
    newSerie.data.key = '';
    newSerie.data.rows = [];
    delete newSerie.data.summary;
    if(metric) {
      newSerie.query.metric = metric;
    }

    return newSerie;
  }

  formatValue(value, metric, seriesName) {
    if(seriesName) {
      let format = _.chain(_.get(this.series, seriesName)).filter({metric}).map('format').value()[0];
      if(_.isFunction(format)) {
        format = format();
      }
      return this.format(value, format);
    }
  }

  getAggregationType(metric) {
    switch(metric) {
      case 'ctr':
      case 'ecpc':
      case 'ecpa':
      case 'ecpm':
        return 'avg';
      default:
        return 'sum';
    }
  }

  orderAndAggregateSmallValues(serie, numberOfEntriesToNotAggregate, metric, translatedMetric, seriesName) {
    serie.data.rows = _.sortBy(serie.data.rows, (row) => { return -row.value; });

    let aggregationType = this.getAggregationType(metric);
    let pointsToAggregate = serie.data.rows.splice(numberOfEntriesToNotAggregate);
    let aggregateValue = 0;
    _.forEach(pointsToAggregate, (point) => {
      aggregateValue += point.value;
    });
    if(aggregationType == 'avg') aggregateValue /= pointsToAggregate.length;

    serie.data.rows.push({
      key: this.translate('others'),
      tooltipTitle: translatedMetric,
      tooltipValue: this.formatValue(aggregateValue, metric, `${seriesName}`),
      aggregateValuesInfo: pointsToAggregate,
      value: aggregateValue
    });

    return serie;
  }

  topValuesPieChartTransformResponse(series, seriesName) {
    let processedSeries = [];
    let metric = _.get(series[0],'query.metric');
    let translatedMetric = this.translate(`$analytics.revenue.${seriesName}.series.${metric}.label`);
    let aggregateValue;
    let formattedAggregateValue;
    let key;

    let newSerie = this.getNewSerie(series, metric);
    newSerie.data.key = translatedMetric;

    processedSeries.push(newSerie);
    _.forEach(series, (serie) => {
      aggregateValue = serie.data.value;
      if(aggregateValue > 0) {
        formattedAggregateValue = this.formatValue(aggregateValue, metric, `${seriesName}`);
        if(seriesName == 'topPlatforms' || seriesName == 'topChannels') {
          key = this.translate(_.get(serie,'data.key'));
        } else if(seriesName == 'topCountries') {
          key = this.translate(`countryCodes.${_.get(serie,'data.key')}`);
        } else if(seriesName == 'topGames') {
          const gameData = _.find(this.allGamesOfAllGameDevelopers, game => game.id === parseInt(_.get(serie,'data.key')))
          key = (gameData && gameData.name) ? gameData.name : 'N/A';
        } else if(seriesName == 'topGameDevelopers') {
          const gameDeveloperData = _.find(this.gameDevelopers, gameDeveloper => gameDeveloper.id === parseInt(_.get(serie,'data.key')))
          key = (gameDeveloperData && gameDeveloperData.company_name) ? gameDeveloperData.company_name : 'N/A';
        }
        processedSeries[0].data.rows.push({
          key,
          value: aggregateValue,
          tooltipTitle: translatedMetric,
          tooltipValue: formattedAggregateValue
        });
      }
    });

    if(processedSeries[0].data.rows.length > 5) {
      processedSeries[0] = this.orderAndAggregateSmallValues(processedSeries[0], 5, metric, translatedMetric, seriesName);
    }

    return processedSeries;
  }

  setGamesOfSelectedDeveloper(gameDeveloper) {
    this.gamesOfSelectedGameDeveloper = _.filter(this.allGamesOfAllGameDevelopers, (game) => {
      return game.game_developer_id == gameDeveloper.id;
    });
  }

  updateCampaignAnalyticsQuery() {
    this.$localStorage.timeframe = this.timeframe;

    if (!this.game) {
      return;
    }

    let query = {
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    };

    this.query.onNext(query);
  }

  getCsvFilename(seriesName) {
    if (this.currentGameDeveloper && this.currentGameDeveloper.value && this.currentGameDeveloper.value.company_name) {
      return `${this.currentGameDeveloper.value.company_name}_ALL_${seriesName}_${moment(this.timeframe.startDate).format('YYYY-MM-DD')}_${moment(this.timeframe.endDate).format('YYYY-MM-DD')}`;
    }
    return null;
  }

  enrichGames(games, gameDevelopers) {
    _.forEach(games, (game) => {
      this.setPlatformsFlags(game);
      if(gameDevelopers instanceof Array) {
        game.gameDeveloperName = _.chain(gameDevelopers).filter(gd => gd.id === game.game_developer_id).map('company_name').value()[0];
      } else {
        game.gameDeveloperName = gameDevelopers.company_name;
      }
    });
  }

  getGames(getAllGameDevelopers) {
    this.promises = [];
    this.promises.push(this.GamesLimitedResource.getList());

    this.promises.push(getAllGameDevelopers ?
      this.GameDevelopersResource.getList() :
      this.GameDevelopersResource.one(this.user.game_developer_ids[0]).get()
    );

    this.$q.all(this.promises).then(([games, gd]) => {
      if(getAllGameDevelopers) {
        this.allGamesOfAllGameDevelopers = games;
        this.gameDevelopers = gd;
        this.currentGameDeveloper.onNext(gd[0]);
        this.enrichGames(this.allGamesOfAllGameDevelopers, gd);
      } else {
        this.gamesOfSelectedGameDeveloper = games;
        this.currentGameDeveloper.onNext(gd);
        this.enrichGames(this.gamesOfSelectedGameDeveloper, gd);
      }
    });
  }

  setPlatformsFlags(game) {
    _.forEach(game.platforms, (platform) => {
      game['has_platform_' + platform.toLowerCase()] = true;
    });
  }

}

let GamesRevenueComponent = {
  template: ($element, $attrs) => { return template; },
  controller: GamesRevenueController,
  controllerAs: 'vm',
  bindings: true
};

export default angular.module('app.components.games.revenue', [
  ngStorage.name,
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .component('gamesRevenue', GamesRevenueComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/revenue/gamesRevenue.js
 **/